import { Component, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ChatService } from '../chat.service';
import { ModalService } from '@app/modal/modal.service';
import { NotificationService } from '@app/notification/notification.service';
import { ModalBoxComponent } from '@shared/modal-box/modal-box.component';

@Component({
  selector: 'app-tip-rain-modal',
  templateUrl: './tip-rain-modal.component.html',
  styleUrls: ['./tip-rain-modal.component.scss'],
  imports: [ModalBoxComponent, FormsModule],
})
export class TipRainModalComponent {
  tipAmount = 1;
  readonly submitting = signal(false);

  constructor(private chatService: ChatService, private notificationService: NotificationService, private modalService: ModalService) {}

  async tipRain() {
    if (this.submitting()) {
      return;
    }

    if (!(this.tipAmount > 0)) {
      this.notificationService.error('Enter an amount greater than 0.', 'Tip Rain');
      return;
    }

    this.submitting.set(true);
    try {
      const response = await this.chatService.tipRain(this.tipAmount);
      if (response) {
        this.notificationService.success(`You have tipped ${this.tipAmount.toFixed(2)} to the the rain!`, 'Tip Rain');
      }
      this.modalService.close();
    } catch {
      // The emit path has already reported the failure — keep the modal open for a retry.
    } finally {
      this.submitting.set(false);
    }
  }
}
